import Cookies from 'js-cookie';

import type { IGoodInCart } from 'entities/products';

import checkAuth from 'global/api/auth';
import { api } from 'global/api';

export const getCartData = async () => {
  let initialGoods: IGoodInCart[] = [];
  let initialPrice = 0;
  let withCountChange = false;

  try {
    await checkAuth({ cookies: { token: Cookies.get('token') } }, true);
    const cartRes = await api.getCart();

    const cart = cartRes.data.data;

    initialPrice = cart.order_price / 100;
    initialGoods = cart.products.map((good) => {
      return {
        quantity: good.quantity,
        price: good.price / 100,
        list_price: good.list_price / 100,
        product: {
          ...good.product,
          price: good.product.price / 100,
          list_price: good.product.list_price ? good.product.list_price / 100 : null,
        },
      };
    });

    if (cart.basket_changed) {
      withCountChange = true;
    }
  } catch (error) {
    return {
      initialGoods,
      initialPrice,
      withCountChange,
    };
  }

  return {
    initialGoods,
    initialPrice,
    withCountChange,
  };
};
